<template>
  <div>
    <section>
      <h1>Populate Templates</h1>
      <button style="color: red" class="is-primary" @click="deleteAll">
          Delete all
      </button>

      <p>Deleted: {{deleted/siteTemplates.length}}</p>

      <div>
        <button class="is-primary" @click="convertAll">
          Start Conversion
        </button>
      </div>

      <div v-if="converting">
        <p>Template {{ templatesConverted }}/{{ siteTemplates.length }} Populated</p>
      </div>
    </section>
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import siteTemplates from '@/mixins/siteTemplates'

import {
  readTemplatesData,
  createTemplateData,
  deleteTemplateData
} from '@/lib/templates'

export default {
  name: 'admin-replace-templates',

  mixins: [page, pagination, siteTemplates],

  data() {
    return {
      converting: false,
      templatesConverted: 0,
      deleted: 0
    }
  },

  methods: {
    deleteAll() {
      readTemplatesData().then(({data}) => {
        data.forEach((temp, index) => {
          window.setTimeout(() => {
            deleteTemplateData(temp.id)
          }, 250 * index)
        })
      })
    },

    convertAll() {
      this.converting = true

      this.siteTemplates.forEach((template, index) => {
        window.setTimeout(() => {
          let temp = {
            site_template: {
              name: template.key,
              slug: template.key.replace(/\s+/g, '-').toLowerCase(),
              content: template.value
            }
          }

          createTemplateData(temp).then(() => {
            this.templatesConverted++
          })
        }, 250 * index)
      })
    }
  }
}
</script>
